if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
}

function setScrollbarWidthVariable() {
  const scrollDiv = document.createElement("div");
  scrollDiv.style.visibility = "hidden";
  scrollDiv.style.overflow = "scroll";
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px";
  scrollDiv.style.width = "100px";
  scrollDiv.style.height = "100px";

  document.body.appendChild(scrollDiv);

  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

  document.body.removeChild(scrollDiv);
}

window.addEventListener('load', setScrollbarWidthVariable);